// extracted by mini-css-extract-plugin
module.exports = {"delivery-message":"delivery-message-3OKQbN4","form-item-label":"form-item-label-3-KOoDc","form-item-content":"form-item-content-2zTH7Qw"};